import React, { FC, SyntheticEvent, useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import StaffbaseSettings from './index';
import WebAppOnly from './WebAppOnly';
import { TAppState } from '../../../reducers';
import { triggerFetch } from '../../../actions/thirdPartyContent';
import { ISBPost } from '../../../types/thirdPartyContent';
import rules from '../../../constants/businessRules/businessRules';
import * as Styled from './styles';

interface IProps {
    staffbaseBlock: any;
    isWebApp: boolean;
    isText: boolean;
    loadingPosts: boolean;
    posts: ISBPost[];
    dispatch: Dispatch<any>;
}

const SbRightPanel: FC<IProps> = ({ staffbaseBlock, isWebApp, isText, loadingPosts, posts, dispatch }) => {
    const [postFetchContentOffset, setPostFetchContentOffset] = useState(rules.THIRD_PARTY_SB_POSTS_LOAD_BATCH_SIZE);
    // we assume the initial content is at least batch size if we consider fetching more items
    const [contentLengthBeforeLazyLoad, setContentLengthBeforeLazyLoad] = useState(
        rules.THIRD_PARTY_SB_POSTS_LOAD_BATCH_SIZE
    );
    const [searchQuery, setSearchQuery] = useState('');

    const resetLazyLoading = (query: string = '') => {
        setPostFetchContentOffset(rules.THIRD_PARTY_SB_POSTS_LOAD_BATCH_SIZE);
        setContentLengthBeforeLazyLoad(rules.THIRD_PARTY_SB_POSTS_LOAD_BATCH_SIZE);
        setSearchQuery(query);
    };

    if (!isWebApp) {
        return <WebAppOnly />;
    }

    return (
        <Styled.SbRightPanelDiv
            className="scrollFix"
            isText={isText}
            onScroll={(e: SyntheticEvent) => {
                const { clientHeight, scrollHeight, scrollTop } = e.currentTarget;

                if (
                    !loadingPosts &&
                    !searchQuery &&
                    scrollTop !== 0 &&
                    Math.round(clientHeight + scrollTop) === scrollHeight
                ) {
                    // it will set to fetch more content if we were able to load all batch items
                    if (
                        contentLengthBeforeLazyLoad === rules.THIRD_PARTY_SB_POSTS_LOAD_BATCH_SIZE ||
                        Math.abs(contentLengthBeforeLazyLoad - posts.length) ===
                            rules.THIRD_PARTY_SB_POSTS_LOAD_BATCH_SIZE
                    ) {
                        dispatch(
                            triggerFetch('posts', {
                                limit: rules.THIRD_PARTY_SB_POSTS_LOAD_BATCH_SIZE.toString(),
                                offset: postFetchContentOffset.toString(),
                            })
                        );
                        setPostFetchContentOffset(postFetchContentOffset + rules.THIRD_PARTY_SB_POSTS_LOAD_BATCH_SIZE);
                        setContentLengthBeforeLazyLoad(posts.length);
                    }
                }
            }}
        >
            <StaffbaseSettings block={staffbaseBlock} resetLazyLoading={resetLazyLoading} />
        </Styled.SbRightPanelDiv>
    );
};

const mapStateToProps = (state: TAppState) => ({
    loadingPosts: state.thirdPartyContent.staffbase.loadingPosts,
    posts: state.thirdPartyContent.staffbase.posts as ISBPost[],
});

export default connect(mapStateToProps)(SbRightPanel);
